import { Group, Paper, Text } from "@mantine/core";
import { HeldEmailBulkButtons } from "./HeldEmailBulkButtons";

interface HeldEmailBulkActionBarProps {
  selectedCount: number;
  onRelease: () => void;
  onCancel: () => void;
}

export function HeldEmailBulkActionBar({
  selectedCount,
  onRelease,
  onCancel,
}: HeldEmailBulkActionBarProps) {
  if (selectedCount === 0) return null;
  return (
    <Paper p="sm" withBorder>
      <Group justify="space-between">
        <Text fw={600}>{selectedCount} selected</Text>
        <HeldEmailBulkButtons onCancel={onCancel} onRelease={onRelease} />
      </Group>
    </Paper>
  );
}
